import { FETCH_GROUP_TYPES } from 'actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_GROUP_TYPES:
			return action.payload;
		default:
			return state;
	}
};
